import setCurrentPage from "src/Utils/setCurrentPage";

const CHARACTERS_TO = [
  {
    title: "Field Operations \nRegional Manager",
    subtitle: "",
    items: [
      "Improved job completion \nrate per technician",
      "Operational efficiency",
      "Service improvements to \nthe customer",
    ],
    image: "characters/character_to_1.png",
    next: {
      label: "TURF OPTIMIZATION DEMO",
      onClick: () => {
        setCurrentPage(405);
      },
      endIcon: "arrow-right",
    },
    gif: "characters/character_to_1.gif",
    gifStyle: {
      position: "relative",
      width: "260px",
      height: "349px",
      overflow: "hidden",
    },
  },
];

export const DATA_CHARACTERS_TO = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: "Challenges solved",
  bgImage: "TURF_OPTIMIZATION/TO_bg_4.png",
  characters: CHARACTERS_TO,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(403),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  actions: [
    {
      label: "TURF OPTIMIZATION DEMO",
      onClick: () => {
        setCurrentPage(405);
      },
      endIcon: "arrow-right",
    },
  ],
};
